// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2Tthy","question":"Question_question__2QGh4","description":"Question_description__2RZD4"};